<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import Table from '../common/SortedTable.vue'

export default {
    name: 'EventsComponent',
    components: {
        Table
    },

    props: {
        events: {
            type: Array,
            requiered: true
        },
        selectedItem: {
            type: Number,
            default: -1
        },
        languageStrings: {
            type: Object,
            default: null
        }
    },

    emits: ['selected-event'],

    computed: {
        headers() {
            let h = [
                {
                    id: 'date-from',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.event007 != null ? this.languageStrings.ui.event007 : 'Od'),
                    sort: true
                },
                {
                    id: 'date-to',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.event008 != null ? this.languageStrings.ui.event008 : 'Do'),
                    sort: true
                },
                {
                    id: 'category',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.event005 != null ? this.languageStrings.ui.event005 : 'Kategorie'),
                    sort: true
                },
                {
                    id: 'description',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.event006 != null ? this.languageStrings.ui.event006 : 'Popis'),
                    sort: true
                }
            ]

            return h
        },
        rows() {
            let r = []

            for (let i = 0; i < this.events.length; i++) {
                r.push({
                    id: this.events[i].id,
                    selected: (this.selectedItem === this.events[i].id),
                    cells: [
                        {
                            id: 'date-from',
                            contenttype: 'text',
                            content: (this.events[i].dateFrom != null ? this.formatDateTime(this.events[i].dateFrom) : '')
                        },
                        {
                            id: 'date-to',
                            contenttype: 'text',
                            content: (this.events[i].dateTo != null ? this.formatDateTime(this.events[i].dateTo) : '')
                        },
                        {
                            id: 'category',
                            contenttype: 'text',
                            content: (this.events[i].category != null && this.events[i].category.name != null ? this.events[i].category.name : '')
                        },
                        {
                            id: 'description',
                            contenttype: 'text',
                            content: (this.events[i].description != null ? this.events[i].description : ''),
                            width: 300 
                        }
                    ]
                })
            }

            return r
        }
    },
    
    methods: {
        formatDateTime(date) {
            return date !== null ? dayjs(date + 'Z').utcOffset(0).format('D.M.YYYY H:mm') : ''
        },
        setSelectedEvents(value) {
            this.$emit('selected-event', value[0])
        }
    }
}
</script>


<template>
    <Table v-if="events.length > 0" :headers="headers" :rows="rows" @selected-items="setSelectedEvents" />
</template>
